import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';

import { Link } from 'react-router-dom';

const Card = styled.div<CardProp>`
  text-align: center;
  border-radius: 8px;
  padding: 40px;
  position: relative;
  background-image: url(${(props: CardProp) => props.bgImg}),
    linear-gradient(
      to top left,
      ${(props: CardProp) => props.gradientColor.first} 0.01%,
      ${(props: CardProp) => props.gradientColor.second} 100%
    );
  cursor: pointer;
`;
const CardImg = styled.img`
  height: 108px;
  position: absolute;
  top: -40px;
  right: 0px;
`;
const CardTitle = styled.div`
  color: ${colors.BlueGray_0};
  font-family: NotoSansTC-Bold;
  font-size: 28px;
  line-height: 41px;
`;
const CardContent = styled.div`
  color: ${colors.BlueGray_0};
  font-size: 16px;
  line-height: 30px;
  text-align: left;
  margin-top: 12px;
`;

type CardProp = {
  gradientColor: {
    first: string;
    second: string;
  };
  bgImg: string;
};

interface IProps {
  href: string;
  title: string;
  description: string;
  gradientColor: {
    first: string;
    second: string;
  };
  image: string;
  hoverImage: string;
  bgImg: string;
}

// 考慮合併Card
const MobileCard: React.FC<IProps> = ({
  href,
  title,
  description,
  gradientColor,
  image,
  bgImg,
}) => {
  return (
    <Link to={href}>
      <Card bgImg={bgImg} gradientColor={gradientColor}>
        <CardImg src={image} alt="" ></CardImg>
        <CardTitle>{title}</CardTitle>
        <CardContent>{description}</CardContent>
      </Card>
    </Link>
  );
};

export default MobileCard;
